export default __webpack_public_path__ + "static/media/ja1_thumb.8a45311c.jpg";